<template>
    <div>
        <!--        <breadcrumb :routerList="[{title:'OEM付款报表 '}]"/>-->
        <Breadtabsheader/>
        <div class="h-content" style="">
            <!-- tab切换 -->
            <div class=" ">
                <el-tabs v-model="activeName" type="border-card">

                    <el-tab-pane label="改制单列表" name="first" :key="'first'">
                        <reformList   v-if="activeName === 'first'" />
                    </el-tab-pane>
                    <el-tab-pane label="1+N订单列表" name="second" :key="'second'">
                        <dingdlist1N  v-if="activeName === 'second'" />
                    </el-tab-pane>


                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import reformList from './reformList.vue'
import dingdlist1N from './dingdlist1+N.vue'
export default {
    components: {
        //Breadcrumb,
        reformList,dingdlist1N
    },
    data() {
        return {
            // 默认第一个Tab
            activeName: "first",

        };

    },
    created() {
        if(this.$route.query.type){
            this.activeName = this.$route.query.type;
        }

    },
    methods: {
        //tab切换
        handleClick(tab) {




        },

    }
}
</script>
<style scoped>
.h-content{
    background: #fff
}
</style>
